import type { StaleState } from './types';

export function computeStaleState(lastUpdatedAt: number | null, thresholdMs: number): StaleState {
    if (!lastUpdatedAt) {
        return {
            stale: true,
            ageMs: Number.POSITIVE_INFINITY,
            thresholdMs,
        };
    }

    const ageMs = Math.max(0, Date.now() - lastUpdatedAt);
    return {
        stale: ageMs > thresholdMs,
        ageMs,
        thresholdMs,
    };
}

export function formatAge(ageMs: number): string {
    if (!Number.isFinite(ageMs)) return 'unknown';
    if (ageMs < 1000) return `${ageMs}ms`;
    if (ageMs < 60000) return `${Math.floor(ageMs / 1000)}s`;
    return `${Math.floor(ageMs / 60000)}m`;
}
